export function createBaseModule(options = {}) {
    const baseState = {
        data: null,
        loading: false,
        error: null,
        loaded: false
    };

    const baseMutations = {
        SET_LOADING(state, status) {
            state.loading = status;
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
        SET_DATA(state, data) {
            state.data = data.data;
            state.loaded = true;
        },
        RESET_STATE(state) {
            Object.assign(state, baseState);
        }
    };

    return {
        namespaced: true,
        state: {
            ...baseState,
            ...(options.state || {})
        },
        mutations: {
            ...baseMutations,
            ...(options.mutations || {})
        },
        actions: options.actions || {},
        getters: options.getters || {}
    };
}
